import { ColumnsType } from 'antd/lib/table';
import { SortCondition } from 'shared/enums';
import { PresetStatusColorType } from 'antd/lib/_util/colors';
import { TVacationsEmployee } from './vacations.types';

export type TDayOffColumns = ColumnsType<TPreparedDayOffPublicated>;

export enum DayOffTypes {
  day = 'day',
  hour = 'hour',
}

export enum IDecisionStatus {
  draft = 'draft',
  consideredBySupervisor = 'consideredBySupervisor',
  consideredByHR = 'consideredByHR',
  approvedBySupervisor = 'approvedBySupervisor',
  approvedByHR = 'approvedByHR',
  rejectedBySupervisor = 'rejectedBySupervisor',
  rejectedByHR = 'rejectedByHR',
  takenToWorkByHR = 'takenToWorkByHR',
  changeResponsibleByHR = 'changeResponsibleByHR',
  canceledByHR = 'canceledByHR',
  ready = 'ready',
  canceled = 'canceled',
}

export const DayOffsStatusesMap = {
  [IDecisionStatus.approvedByHR]: 'Согласована HR',
  [IDecisionStatus.approvedBySupervisor]: 'Согласована руководителем',
  [IDecisionStatus.canceled]: 'Отменена',
  [IDecisionStatus.canceledByHR]: 'Отменена HR',
  [IDecisionStatus.changeResponsibleByHR]: 'Ответственный сменен HR',
  [IDecisionStatus.consideredByHR]: 'На рассмотрении HR',
  [IDecisionStatus.consideredBySupervisor]: 'На рассмотрении руководителем',
  [IDecisionStatus.draft]: 'Черновик',
  [IDecisionStatus.ready]: 'Готово',
  [IDecisionStatus.rejectedByHR]: 'Отклонена HR',
  [IDecisionStatus.rejectedBySupervisor]: 'Отклонена руководителем',
  [IDecisionStatus.takenToWorkByHR]: 'Взято в работу HR',
};

export const DayOffsStatusTypesMap: Record<IDecisionStatus, PresetStatusColorType> = {
  [IDecisionStatus.approvedByHR]: 'success',
  [IDecisionStatus.approvedBySupervisor]: 'success',
  [IDecisionStatus.canceled]: 'error',
  [IDecisionStatus.canceledByHR]: 'error',
  [IDecisionStatus.changeResponsibleByHR]: 'warning',
  [IDecisionStatus.consideredByHR]: 'warning',
  [IDecisionStatus.consideredBySupervisor]: 'warning',
  [IDecisionStatus.draft]: 'default',
  [IDecisionStatus.ready]: 'success',
  [IDecisionStatus.rejectedByHR]: 'error',
  [IDecisionStatus.rejectedBySupervisor]: 'error',
  [IDecisionStatus.takenToWorkByHR]: 'warning',
};

export type TPreparedDayOffPublicated = {
  id: number;
  key: number;
  created: string;
  fio: string;
  dayOffDate: string;
  status: string;
  endedAt?: any;
  startedAt?: any;
  employee: TVacationsEmployee;
};

export type TDayOffResponse = {
  id: number;
  created: string;
  status: IDecisionStatus;
  type: DayOffTypes;
  amount: number;
  date: string;
  comment: string;
  docGuid: string | null;
  docNumber: string | null;
  docDate: string | null;
  docIsUpdated: boolean;
  isComplete: boolean;
  organizationId: string;
  employeeId: number;
  rejectionReason: string | null;
  supervisorId: number;
  employee: TVacationsEmployee;
  supervisor: TVacationsEmployee;
  hr: TVacationsEmployee;
};

export type TDayOffResponseCanceled = {
  id: number;
  created: string;
  status: IDecisionStatus;
  comment: string | null;
  requestId: number;
  rejectionReason: string | null;
  request: TDayOffSingleResponse;
  supervisor: TVacationsEmployee;
  hr: TVacationsEmployee;
};

export enum DayOffTabs {
  new = 'new',
  my = 'my',
  myArchive = 'myArchive',
}

export type TDayOffSingleResponse = {
  hr: TVacationsEmployee;
  id: number;
  date: string;
  type: DayOffTypes;
  amount: number;
  status: IDecisionStatus;
  comment: string;
  created: string;
  docDate: string;
  docGuid: string;
  employee: TVacationsEmployee;
  docNumber: string | number | null;
  isComplete: boolean;
  supervisor: TVacationsEmployee;
  docIsUpdated: boolean;
  organizationId: string;
  rejectionReason: string | null;
};

export type DayOffsRequest = {
  type: DayOffTabs;
  size?: number | null;
  page?: number | null;
  order?: SortCondition;
  byId?: string;
  fio?: string;
  all?: boolean;
  allAvailableOrganizations: boolean;
  personnelNumber?: string;
  positionName?: string;
};

export type DayOffsResponse = {
  data: TDayOffResponse[] | null;
  pagination: {
    size: number;
    page: number;
    total: number;
  } | null;
};

export type DayOffsResponseCancel = {
  data: TDayOffResponseCanceled[] | null;
  pagination: {
    size: number;
    page: number;
    total: number;
  } | null;
};

export type TakeToWorkInfo = {
  requestId?: number | string;
};
export type RejectDayOffRequest = {
  requestId?: number;
  rejectionReason: string;
};
